import React from 'react';

// LPS wordmark - brain glyph + text, matches the lps.solutions brand.
const LPSLogo = ({ width = 120, height = 32, color = 'currentColor', compact = false, className, style }) => (
  <span
    className={className}
    style={{
      display: 'inline-flex', alignItems: 'center', gap: 8,
      height, color, fontWeight: 800, letterSpacing: '0.02em',
      fontSize: Math.min(height * 0.62, 22), lineHeight: 1, ...style,
    }}
  >
    <span style={{ fontSize: Math.min(height * 0.8, 26) }} aria-hidden="true">🧠</span>
    {!compact && (
      <span>
        LPS <span style={{ fontWeight: 500, opacity: 0.85 }}>Solutions</span>
      </span>
    )}
  </span>
);

export default LPSLogo;
